// extracted by mini-css-extract-plugin
export default {"globalsDonut":"GlobalsDonut_globalsDonut__-Z4kE","empty":"GlobalsDonut_empty__pan1Y"};